// Package Imports
import axios from "axios";

// Project Imports
import * as APITypes from "constants/API";
import StorageKeys from "../../../../constants/StorageKeys";
import updateAddAssuredFamilyProductId from "./updateAddAssuredFamilyProductId";
import generateAddAssuredDataStructure from "./generateAddAssuredDataStructure";

const generateAddAssuredFamilyProductId = async (data, hideModal, needType) => {
 
  generateAddAssuredDataStructure(data, needType);
  if (hideModal) hideModal()

  // API Call
  const apiResponse = await axios.post(
    APITypes.CREATE_FAMILY_PRODUCT_ID,
    data
  );
  if (apiResponse.data.status.toLowerCase() === "success") {
    localStorage.setItem(
      StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM,
      false
    );
    updateAddAssuredFamilyProductId(data, apiResponse.data, needType);
  }
};

export default generateAddAssuredFamilyProductId;
